<template>
  <collective-detail
    breadcrumb-route="services"
    item-type="services"
    item-type-single="service"
  />
</template>

<script>
import CollectiveDetail from '@/views/apps/collectives/components/CollectiveDetail.vue';

export default {
  name: 'ServicesDetails',
  components: {
    CollectiveDetail,
  },
};
</script>
